import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";

import {
  Link,
  useLocation,
} from "react-router-dom";

import authService from "../../services/authService";

// ============================================================
// SIDEBAR MENU CONFIGURATION
// ============================================================

const sidebarLinks = [

  // ==========================================================
  // DASHBOARD
  // ==========================================================

  {
    id: "dashboard",
    label: "Dashboard",
    icon: "bx bx-home-circle",
    path: "/admin/dashboard",
    permission: null,
  },

  // ==========================================================
  // HOMEPAGE
  // ==========================================================

  {
    id: "homepage",
    label: "Home Page Setting Manage",
    icon: "bx bx-cog",

    permission: {
      module: "homepage",
      action: "view",
    },

    dropdown: [

      // {
      //   path: "/admin/sliders",
      //   label: "Sliders",
      //
      //   permission: {
      //     module: "homepage",
      //     action: "view",
      //   },
      // },

      {
        path: "/admin/home-section-products",
        label: "Home section products",

        permission: {
          module: "homepage",
          action: "view",
        },
      },

    ],
  },

  // ==========================================================
  // MARKETING
  // ==========================================================

  {
    id: "marketing",
    label: "Advertise Management",
    icon: "bx bx-broadcast",

    permission: {
      module: "marketing",
      action: "view",
    },

    dropdown: [

      {
        path: "/admin/sliders",
        label: "Sliders",

        permission: {
          module: "homepage",
          action: "view",
        },
      },

      {
        path: "/admin/advertise-section-products",
        label: "Advertise Management",

        permission: {
          module: "marketing",
          action: "view",
        },
      },

    ],
  },

  // ==========================================================
  // PRODUCTS
  // ==========================================================

  {
    id: "products",
    label: "Product Manage",
    icon: "bx bx-package",

    permission: {
      module: "products",
      action: "view",
    },

    dropdown: [

      {
        path: "/admin/all-products",
        label: "All Products",

        permission: {
          module: "products",
          action: "view",
        },
      },

      {
        path: "/admin/active-products",
        label: "Active Products",

        permission: {
          module: "products",
          action: "view",
        },
      },

      {
        path: "/admin/inactive-products",
        label: "Inactive Products",

        permission: {
          module: "products",
          action: "view",
        },
      },

      {
        path: "/admin/all-sold-products",
        label: "Out of Stock Products",

        permission: {
          module: "products",
          action: "view",
        },
      },

      {
        path: "/admin/all-offers-products",
        label: "Offer Products",

        permission: {
          module: "products",
          action: "view",
        },
      },

      {
        path: "/admin/product/create-bulk",
        label: "Bulk Import Products",

        permission: {
          module: "products",
          action: "import",
        },
      },

    ],
  },

  // ==========================================================
  // ORDERS
  // ==========================================================

  {
    id: "orders",
    label: "Orders Manage",
    icon: "bx bx-cart-alt",

    permission: {
      module: "orders",
      action: "view",
    },

    dropdown: [

      {
        path: "/admin/all-orders",
        label: "All Orders",

        permission: {
          module: "orders",
          action: "view",
        },
      },

      {
        path: "/admin/new-orders",
        label: "New Orders",

        permission: {
          module: "orders",
          action: "view",
        },
      },

      {
        path: "/admin/delivered-orders",
        label: "Delivered Orders",

        permission: {
          module: "orders",
          action: "view",
        },
      },

      {
        path: "/admin/cancelled-orders",
        label: "Cancelled Orders",

        permission: {
          module: "orders",
          action: "view",
        },
      },

      {
        path: "/admin/pending-orders",
        label: "Pending Orders",

        permission: {
          module: "orders",
          action: "view",
        },
      },

    ],
  },

  // ==========================================================
  // PAYMENTS
  // ==========================================================

  // {
  //   id: "payments",
  //   label: "Payment Settings",
  //   icon: "bx bx-credit-card",
  //
  //   permission: {
  //     module: "payments",
  //     action: "view",
  //   },
  //
  //   dropdown: [
  //
  //     {
  //       path: "/admin/cod-settings",
  //       label: "Cod Settings",
  //
  //       permission: {
  //         module: "payments",
  //         action: "view",
  //       },
  //     },
  //
  //     {
  //       path: "/admin/paypal-settings",
  //       label: "Paypal Settings",
  //
  //       permission: {
  //         module: "payments",
  //         action: "view",
  //       },
  //     },
  //
  //     {
  //       path: "/admin/payu-settings",
  //       label: "PayU Settings",
  //
  //       permission: {
  //         module: "payments",
  //         action: "view",
  //       },
  //     },
  //
  //   ],
  // },

  // ==========================================================
  // TRANSACTIONS
  // ==========================================================

  {
    id: "transactions",
    label: "Transactions",
    icon: "bx bx-wallet",
    path: "/admin/transactions",

    permission: {
      module: "payments",
      action: "view",
    },
  },

  // ==========================================================
  // USERS
  // ==========================================================

  {
    id: "userManagement",
    label: "User Management",
    icon: "bx bx-group",
    path: "/admin/user-management",

    permission: {
      module: "users",
      action: "view",
    },
  },

  // ==========================================================
  // CONTACT US
  // ==========================================================

  {
    id: "contactUsList",
    label: "Contact Us List",
    icon: "bx bx-envelope",
    path: "/admin/contact-us-list",

    permission: {
      module: "users",
      action: "view",
    },
  },

  // ==========================================================
  // SHIPPING
  // ==========================================================

  {
    id: "shipping",
    label: "Shipping Rule",
    icon: "bx bx-archive",
    path: "/admin/shipping-rule",

    permission: {
      module: "shipping",
      action: "view",
    },
  },

  // ==========================================================
  // SETTINGS
  // ==========================================================

  // {
  //   id: "settings",
  //   label: "Settings",
  //   icon: "bx bx-cog",
  //   path: "/admin/setting-rule",
  //
  //   permission: {
  //     module: "settings",
  //     action: "view",
  //   },
  // },

];

// ============================================================
// GET ROLE VALUES
// ============================================================

const getRoleValues = (user) => {

  if (!user) {
    return [];
  }

  // JSON string support
  if (typeof user === "string") {

    try {
      user = JSON.parse(user);
    } catch (error) {
      return [user];
    }

  }

  const values = [];

  const addValue = (value) => {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return;
    }

    if (
      typeof value === "string" ||
      typeof value === "number"
    ) {
      values.push(String(value));
      return;
    }

    if (Array.isArray(value)) {

      value.forEach((item) => {
        addValue(item);
      });

      return;
    }

    if (typeof value === "object") {

      addValue(value.name);
      addValue(value.role);
      addValue(value.role_name);
      addValue(value.roleName);
      addValue(value.display_name);
      addValue(value.displayName);
      addValue(value.title);
      addValue(value.label);
      addValue(value.slug);
      addValue(value.key);
      addValue(value.code);

    }

  };

  // ==========================================================
  // ROOT
  // ==========================================================

  addValue(user.role);
  addValue(user.role_name);
  addValue(user.roleName);
  addValue(user.user_role);
  addValue(user.userRole);
  addValue(user.roles);
  addValue(user.userRoles);

  addValue(user.role_id);
  addValue(user.roleId);

  // ==========================================================
  // NESTED USER
  // ==========================================================

  addValue(user.user?.role);
  addValue(user.user?.role_name);
  addValue(user.user?.roleName);
  addValue(user.user?.roles);
  addValue(user.user?.userRoles);
  addValue(user.user?.role_id);
  addValue(user.user?.roleId);

  // ==========================================================
  // DATA
  // ==========================================================

  addValue(user.data?.role);
  addValue(user.data?.role_name);
  addValue(user.data?.roleName);
  addValue(user.data?.roles);
  addValue(user.data?.userRoles);
  addValue(user.data?.role_id);
  addValue(user.data?.roleId);

  // ==========================================================
  // DATA USER
  // ==========================================================

  addValue(user.data?.user?.role);
  addValue(user.data?.user?.role_name);
  addValue(user.data?.user?.roleName);
  addValue(user.data?.user?.roles);
  addValue(user.data?.user?.userRoles);

  return values;

};

// ============================================================
// CHECK SUPER ADMIN
// ============================================================

const checkIsSuperAdmin = (user) => {

  const roles = getRoleValues(user);

  return roles.some((role) => {

    const normalized = String(role)
      .trim()
      .toLowerCase()
      .replace(/[\s_-]/g, "");

    return (
      normalized === "superadmin" ||
      normalized === "superadministrator"
    );

  });

};

// ============================================================
// SIDEBAR COMPONENT
// ============================================================

const Sidebar = ({
  isOpen,
  toggleSidebar,
}) => {

  const location = useLocation();

  const menuRef = useRef(null);

  // ==========================================================
  // STATE
  // ==========================================================

  const [activeMenu, setActiveMenu] =
    useState(null);

  const [isMobile, setIsMobile] =
    useState(
      window.innerWidth < 1280
    );

  // ==========================================================
  // CURRENT USER
  // ==========================================================

  const user =
    authService.getCurrentUser();

  // ==========================================================
  // SUPER ADMIN
  // ==========================================================

  const isSuperAdmin =
    useMemo(
      () => checkIsSuperAdmin(user),
      [user]
    );

  // ==========================================================
  // DEBUG
  // ==========================================================

  useEffect(() => {

    console.log(
      "========== SIDEBAR DEBUG =========="
    );

    console.log(
      "CURRENT USER:",
      user
    );

    console.log(
      "ROLES:",
      getRoleValues(user)
    );

    console.log(
      "IS SUPER ADMIN:",
      isSuperAdmin
    );

    console.log(
      "==================================="
    );

  }, [
    user,
    isSuperAdmin,
  ]);

  // ==========================================================
  // PERMISSION CHECK
  // ==========================================================

  const hasAccess = (
    permission
  ) => {

    // Super Admin sees everything
    if (isSuperAdmin) {
      return true;
    }

    // No permission required
    if (!permission) {
      return true;
    }

    try {

      return authService.hasPermission(
        permission.module,
        permission.action
      );

    } catch (error) {

      console.error(
        "Permission check error:",
        error
      );

      return false;
    }

  };

  // ==========================================================
  // BUILD SIDEBAR
  // ==========================================================

  const visibleSidebarLinks =
    useMemo(() => {

      const result = [];

      sidebarLinks.forEach((menu) => {

        // ====================================================
        // DROPDOWN MENU
        // ====================================================

        if (menu.dropdown) {

          const visibleChildren =
            menu.dropdown.filter(
              (item) =>
                hasAccess(
                  item.permission
                )
            );

          if (
            visibleChildren.length === 0
          ) {
            return;
          }

          // ==================================================
          // ALL ROLES - KEEP DROPDOWN UI
          // ==================================================

          result.push({
            ...menu,
            dropdown: visibleChildren,
          });

          return;

        }

        // ====================================================
        // NORMAL MENU
        // ====================================================

        if (
          hasAccess(
            menu.permission
          )
        ) {

          result.push(menu);

        }

      });

      return result;

    }, [
      user,
      isSuperAdmin,
    ]);

  // ==========================================================
  // TOGGLE DROPDOWN
  // ==========================================================

  const toggleMenu = (menuId) => {

    setActiveMenu((prev) =>
      prev === menuId
        ? null
        : menuId
    );

  };

  // ==========================================================
  // RESIZE
  // ==========================================================

  useEffect(() => {

    const handleResize = () => {

      setIsMobile(
        window.innerWidth < 1280
      );

    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {

      window.removeEventListener(
        "resize",
        handleResize
      );

    };

  }, []);

  // ==========================================================
  // AUTO OPEN DROPDOWN BASED ON CURRENT URL
  //
  // IMPORTANT:
  // DO NOT USE visibleSidebarLinks IN DEPENDENCIES
  // ==========================================================

  useEffect(() => {

    const matchedMenu =
      visibleSidebarLinks.find((menu) =>
        menu.dropdown?.some((item) =>
          location.pathname.startsWith(
            item.path
          )
        )
      );

    if (matchedMenu) {

      setActiveMenu(
        matchedMenu.id
      );

    }

  }, [location.pathname]);

  // ==========================================================
  // AUTO SCROLL ACTIVE ITEM
  // ==========================================================

  useEffect(() => {

    const activeElement =
      menuRef.current?.querySelector(
        ".active-sidebar-item"
      );

    if (
      !activeElement ||
      !menuRef.current
    ) {
      return;
    }

    const container =
      menuRef.current;

    const elementTop =
      activeElement.offsetTop;

    const elementBottom =
      elementTop +
      activeElement.offsetHeight;

    const containerTop =
      container.scrollTop;

    const containerBottom =
      containerTop +
      container.clientHeight;

    if (
      elementTop <
      containerTop
    ) {

      container.scrollTop =
        elementTop;

    } else if (
      elementBottom >
      containerBottom
    ) {

      container.scrollTop =
        elementBottom -
        container.clientHeight;

    }

  }, [
    location.pathname,
    activeMenu,
  ]);

  // ==========================================================
  // ACTIVE PATH
  // ==========================================================

  const isActive = (
    path
  ) => {

    if (!path) {
      return false;
    }

    // ========================================================
    // DASHBOARD
    // ========================================================

    if (
      path ===
      "/admin/dashboard"
    ) {

      return (
        location.pathname ===
        "/admin/dashboard"
      );

    }

    // ========================================================
    // ALL PRODUCTS
    // ========================================================

    if (
      path ===
      "/admin/all-products"
    ) {

      return (
        location.pathname ===
          "/admin/all-products" ||

        location.pathname ===
          "/admin/product/create" ||

        location.pathname.startsWith(
          "/admin/products/edit/"
        )
      );

    }

    // ========================================================
    // SLIDERS
    // ========================================================

    if (
      path ===
      "/admin/sliders"
    ) {

      return (
        location.pathname ===
          "/admin/sliders" ||

        location.pathname ===
          "/admin/slider/create" ||

        location.pathname.startsWith(
          "/admin/slider/edit/"
        )
      );

    }

    // ========================================================
    // HOME SECTION
    // ========================================================

    if (
      path ===
      "/admin/home-section-products"
    ) {

      return (
        location.pathname ===
          "/admin/home-section-products" ||

        location.pathname ===
          "/admin/create-home-section" ||

        location.pathname.startsWith(
          "/admin/home-section/edit/"
        )
      );

    }

    // ========================================================
    // ADVERTISEMENT
    // ========================================================

    if (
      path ===
      "/admin/advertise-section-products"
    ) {

      return (
        location.pathname ===
          "/admin/advertise-section-products" ||

        location.pathname ===
          "/admin/create-advertisement-section" ||

        location.pathname.startsWith(
          "/admin/advertisement/edit/"
        )
      );

    }

    // ========================================================
    // OTHER
    // ========================================================

    return (
      location.pathname ===
      path
    );

  };

  // ==========================================================
  // CHECK IF SUBMENU IS ACTIVE
  // ==========================================================
  // THIS IS THE ONLY NEW LOGIC.
  //
  // If a child menu is active, the parent heading will NOT
  // receive the orange color/background.
  // ==========================================================

  const isSubMenuActive = (menu) => {

    if (!menu.dropdown) {
      return false;
    }

    return menu.dropdown.some((item) =>
      isActive(item.path)
    );

  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <>

      {/* ==================================================== */}
      {/* SIDEBAR */}
      {/* ==================================================== */}

      <aside
        style={{

          position:
            "fixed",

          top:
            0,

          bottom:
            0,

          left:
            0,

          width:
            "256px",

          backgroundColor:
            "#fff",

          boxShadow:
            "0 2px 8px rgba(84, 56, 56, 0.1)",

          transform:
            isMobile
              ? (
                  isOpen
                    ? "translateX(0)"
                    : "translateX(-100%)"
                )
              : "translateX(0)",

          transition:
            "transform 0.3s ease-in-out",

          zIndex:
            2000,

          display:
            "flex",

          flexDirection:
            "column",

        }}
      >

        {/* ================================================= */}
        {/* SIDEBAR HEADER */}
        {/* ================================================= */}

        <div
          style={{

            padding:
              "0.2rem 0.2rem 0rem 1rem",

            display:
              "flex",

            alignItems:
              "center",

            justifyContent:
              "space-between",

          }}
        >

          <Link
            to="/admin/dashboard"
            style={{

              display:
                "flex",

              textDecoration:
                "none",

            }}
          >

            <img
              src="/vitauralogo.jpg"
              style={{

                height:
                  "60px",

                width:
                  "140px",

                objectFit:
                  "contain",

                marginLeft:
                  "20px",

              }}
              alt="Vitaura Logo"
            />

          </Link>

          {/* ================================================= */}
          {/* MOBILE CLOSE */}
          {/* ================================================= */}

          {isMobile && (

            <Link
              to="#"
              onClick={(e) => {

                e.preventDefault();

                toggleSidebar();

              }}
              style={{

                fontSize:
                  "1.5rem",

                color:
                  "#566a7f",

              }}
            >

              <i className="bx bx-x" />

            </Link>

          )}

        </div>

        {/* ================================================= */}
        {/* SIDEBAR CONTENT */}
        {/* ================================================= */}

        <ul
          ref={menuRef}
          style={{

            listStyle:
              "none",

            padding:
              "0.25rem 0",

            margin:
              0,

            flex:
              1,

            overflowY:
              "auto",

            scrollBehavior:
              "auto",

          }}
        >

          {visibleSidebarLinks.map(
            (menu) => (

              <React.Fragment
                key={
                  menu.id
                }
              >

                {/* ========================================= */}
                {/* NORMAL MENU */}
                {/* ========================================= */}

                <li
                  style={{
                    padding:
                      "0.01rem 0.1rem",
                  }}
                >

                  {/* ======================================= */}
                  {/* DROPDOWN */}
                  {/* ======================================= */}

                  {menu.dropdown ? (

                    <>

                      {/* =================================== */}
                      {/* DROPDOWN HEADER */}
                      {/* =================================== */}

                      <button
                        type="button"
                        onClick={() => {

                          toggleMenu(
                            menu.id
                          );

                        }}
                        style={{

                          width:
                            "100%",

                          display:
                            "flex",

                          alignItems:
                            "center",

                          textDecoration:
                            "none",

                          /*
                           * CHANGED:
                           * Parent is orange ONLY when
                           * dropdown is open AND no child
                           * is currently active.
                           */
                        color:
  activeMenu === menu.id ||
  isSubMenuActive(menu)
    ? "#FB6C22"
    : "#566a7f",

                          /*
                           * CHANGED:
                           * Parent background is shown ONLY
                           * when dropdown is open AND no child
                           * is currently active.
                           */
                       backgroundColor: "transparent",

                          padding:
                            "0.25rem 0.4rem",

                          borderRadius:
                            "4px",

                          cursor:
                            "pointer",

                          border:
                            "none",

                          textAlign:
                            "left",

                          fontSize:
                            "inherit",

                        }}
                      >

                        <i
                          className={
                            menu.icon
                          }
                          style={{

                            marginRight:
                              "0.5rem",

                          }}
                        />

                        <span>
                          {menu.label}
                        </span>

                        <i
                          className={
                            activeMenu ===
                            menu.id
                              ? "bx bx-chevron-up"
                              : "bx bx-chevron-down"
                          }
                          style={{

                            marginLeft:
                              "auto",

                          }}
                        />

                      </button>

                      {/* =================================== */}
                      {/* DROPDOWN CHILDREN */}
                      {/* =================================== */}

                      <ul
                        style={{

                          listStyle:
                            "none",

                          paddingLeft:
                            "1.5rem",

                          paddingTop:
                            "0",

                          margin:
                            0,

                          display:
                            activeMenu ===
                            menu.id
                              ? "block"
                              : "none",

                        }}
                      >

                        {menu.dropdown.map(
                          (
                            item,
                            index
                          ) => (

                            <li
                              key={
                                item.path ||
                                index
                              }
                            >

                              <Link
                                to={
                                  item.path
                                }
                                className={
                                  isActive(
                                    item.path
                                  )
                                    ? "active-sidebar-item"
                                    : ""
                                }
                                style={{

                                  display:
                                    "block",

                                  padding:
                                    "0.15rem 0.5rem",

                                  textDecoration:
                                    "none",

                                  /*
                                   * CHILD ACTIVE STYLE
                                   * REMAINS SAME
                                   */
                                  color:
                                    isActive(
                                      item.path
                                    )
                                      ? "#FB6C22"
                                      : "#566a7f",

                                  fontWeight:
                                    isActive(
                                      item.path
                                    )
                                      ? 600
                                      : 400,

                                  backgroundColor:
                                    isActive(
                                      item.path
                                    )
                                      ? "rgba(22, 78, 79, 0.2)"
                                      : "transparent",

                                  borderRadius:
                                    "4px",

                                }}
                              >

                                {item.label}

                              </Link>

                            </li>

                          )
                        )}

                      </ul>

                    </>

                  ) : (

                    /* =================================== */
                    /* NORMAL / OTHER ROLE */
                    /* =================================== */

                    <Link
                      to={
                        menu.path
                      }
                      className={
                        isActive(
                          menu.path
                        )
                          ? "active-sidebar-item"
                          : ""
                      }
                      style={{

                        display:
                          "flex",

                        alignItems:
                          "center",

                        textDecoration:
                          "none",

                        color:
                          isActive(
                            menu.path
                          )
                            ? "#FB6C22"
                            : "#566a7f",

                        backgroundColor:
                          isActive(
                            menu.path
                          )
                            ? "rgba(22, 78, 79, 0.2)"
                            : "transparent",

                        padding:
                          "0.35rem 0.5rem",

                        borderRadius:
                          "4px",

                      }}
                    >

                      <i
                        className={
                          menu.icon
                        }
                        style={{

                          marginRight:
                            "0.5rem",

                        }}
                      />

                      <span>
                        {menu.label}
                      </span>

                    </Link>

                  )}

                </li>

              </React.Fragment>

            )
          )}

        </ul>

      </aside>

      {/* ==================================================== */}
      {/* MOBILE OVERLAY */}
      {/* ==================================================== */}

      {isOpen &&
        isMobile && (

          <div
            onClick={
              toggleSidebar
            }
            style={{

              position:
                "fixed",

              top:
                0,

              left:
                0,

              right:
                0,

              bottom:
                0,

              backgroundColor:
                "rgba(0, 0, 0, 0.5)",

              zIndex:
                1999,

            }}
          />

        )}

    </>
  );
};

export default Sidebar;